import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api";

export const doGetAllZones = createAsyncThunk(
  "zones/getAllZones",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.getAllZones(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);

export const doCreateZone = createAsyncThunk(
  "zones/doCreateZone",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doCreateZone(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);


export const doUpdateZone = createAsyncThunk(
  "zones/doUpdateZone",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doUpdateZone(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);

export const doDetailZone = createAsyncThunk(
  "zones/doDetailZone",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doDetailZone(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);

export const doDeleteZone = createAsyncThunk(
  "zones/doDeleteZone",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doDeleteZone(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);

export const doReGeocodeZone = createAsyncThunk(
  "zones/doReGeocodeZone",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doReGeocodeZone(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);
